// extracted by mini-css-extract-plugin
var _1 = "FloatingArrow-module__arrow--i_jvj";
var _2 = "FloatingArrow-module__arrowBg--KLUh7";
var _3 = "FloatingArrow-module__arrowStroke--emv_y";
var _4 = "FloatingArrow-module__arrowStrokeBottom--CD4Uh";
var _5 = "--floating-arrow-border-compensation";
export { _1 as "arrow", _2 as "arrowBg", _3 as "arrowStroke", _4 as "arrowStrokeBottom", _5 as "borderCompensationProperty" }
